import './bootstrap';

// Env
import { Controller } from './controllers';
const frontController = new Controller();

// We'll load jQuery and libraries.
try {
  window.$ = window.jQuery = require('jquery');

  require('jquery-confirm');
  // require('../../../node_modules/...');
} catch (e) {}

// Helpers
import {
  FNEnvironment,
  FNFormValidation
} from './helpers';

// Utilities
import {
  FNAlerts,
  Menu
} from './utilities';

// Define
const fnEnvironment = new FNEnvironment;
const fnFormValidation = new FNFormValidation;
const fnAlerts = new FNAlerts;
const menu = new Menu();

// Initializers
function docReady() {
  // Framework initializers
  frontController.dispatch();

  // App & Utilities & Helpers
  fnAlerts.errors();
  fnAlerts.success();

  menu.init();
}

function winLoad() {
  // Framework initializers
  // ...
  fnFormValidation.validate();

  // App & Utilities & Helpers
  // ...
}

function docReadyWinload() {
  // Framework initializers
  fnEnvironment.set();

  // App & Utilities & Helpers
  // ...
}

function resize() {
  // Framework initializers
  // ...

  // App & Utilities & Helpers
  // ...
}

// [IMPORTANT] Do not change or add anything!
$(document).ready(function() {
  docReady();
  docReadyWinload();
  resize();
  $(window).resize(function() {
    resize();
  });
});
$(window).on('load', function() {
  winLoad();
  docReadyWinload();
  resize();
  $(window).resize(function() {
    resize();
  });
});

// [IMPORTANT] Ajax fallback
/*$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
  let token;
  if (!options.crossDomain) {
    token = $('meta[name="token"]').attr('content');
    if (token) {
      return jqXHR.setRequestHeader('X-CSRF-Token', token);
    }
  }
});

$.ajaxSetup({
  statusCode: {
    401: function () {
      location.href = '/login';
    },
    403: function () {
      location.href = '/login';
    }
  }
});*/



// WEBPACK FOOTER //
// ./resources/assets/js/app.js